import { jsx as m } from "react/jsx-runtime";
import { c as p } from "../../index-Cu0xwYjD.js";
import { ColCssClass as s, ColAlignSelf as n, ColOffset as C, ColSpan as S } from "./Col.types.js";
import { getResponsiveLayoutModifiers as f } from "../../utils/helpers.responsive.js";
const o = ({
  alignSelf: e,
  children: l,
  className: t,
  offset: a,
  span: r = "auto",
  ...i
}) => /* @__PURE__ */ m(
  "div",
  {
    className: p(
      t,
      s.Base,
      f(s.Span, r, "12"),
      f(s.Offset, a),
      {
        [`${s.AlignSelf}--${e}`]: !!e
      }
    ),
    ...i,
    children: l
  }
);
o.AlignSelf = n;
o.Offset = C;
o.Span = S;
export {
  o as IressCol
};
